export default function isRunningInIframe(): boolean {
    return window.location !== window.parent.location;
}
